import React from "react";

function Devices() {
  return <div>Devices</div>;
}

export default Devices;
